'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var TextWithIcon = function (props) {
    var icon = props.icon, text = props.text;
    return (React__default.createElement(styledComponents.TextIconContainer, null,
        icon,
        React__default.createElement(core.Typography, { variant: 'h4' }, text)));
};

module.exports = TextWithIcon;
